import { message } from 'antd';
import { AppPages } from '../project/Defines';
import { Project } from '../project/Project';
import { hideLoader } from '../Shared/Loader';
import store from '../store';
import { logout } from '../store/actions';

const api_url = process.env.REACT_APP_API_URL;

function doProcess(options, method) { //NOSONAR
    const formData = new FormData();
    const controller = new AbortController();
    const { signal } = controller;

    function buildFormData(formData, data, parentKey) {
        if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
            Object.keys(data).forEach(key => {
                buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
            });
            if (parentKey && Object.keys(data).length === 0) {
                formData.append(parentKey, '');
            }
        } else {
            const value = data === null ? '' : data;

            formData.append(parentKey, value);
        }
    }

    let url = (options.absolute ? "" : (api_url || "")) + options.url;
    if (method === "GET") {
        const params = [];
        Object.keys(options.data).forEach(key => params.push(key + "=" + options.data[key]));
        if (params.length > 0) {
            url += "?" + params.join("&");
        }
    }

    let fetchOptions = {
        method: method || "POST"
    }
    if (options.useBody) {
        fetchOptions.body = options.data;
    }
    if (method === "POST") {
        buildFormData(formData, options.data);
        fetchOptions.body = formData;
    }

    let token = store.getState().userToken || "test";

    if (options.download) {
        fetch(url, {
            ...fetchOptions, signal, credentials: 'include', mode: 'cors',
            headers: {
                'USER-TOKEN': token,
                'CULTURE': store.getState().culture,
                'NETWORK-CODE': store.getState().network
            }
        })
            .then(response => response.blob())
            .catch(function (error) {
                if (options.error)
                    options.error(error);
                else
                    message.error(error.message);
            })
            .then(blob => {
                if (blob && blob.type) {
                    try {


                        if (blob.type === "application/problem+json" || blob.type === "application/json") {
                            let reader = new FileReader();
                            reader.readAsText(blob);
                            reader.onload = function () {
                                let error = JSON.parse(reader.result);
                                if (options.error)
                                    options.error(error);
                                else
                                    message.error(error.title || error.message);
                            };
                            return;
                        }

                        if (options.autoDownload) {
                            let url = window.URL.createObjectURL(blob);
                            let a = document.createElement('a');
                            a.href = url;
                            if (options.target)
                                a.target = options.target;
                            document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                            a.click();
                            a.remove();  //afterwards we remove the element again
                        }

                        if (options.success)
                            options.success(blob);
                    }
                    catch (e) {
                        if (options.error)
                            options.error(e);
                        else
                            message.error(e.message);
                    }
                }
            });
    }
    else {
        fetch(url, {
            ...fetchOptions, signal, credentials: 'include', mode: 'cors',
            headers: {
                'USER-TOKEN': token,
                'CULTURE': store.getState().culture,
                'NETWORK-CODE': store.getState().network
            }
        })
            .then((Response) => Response.json())
            .catch(function (error) {
            })
            .then((result) => {
                if (result && result.hasError) {
                    if (result.customErrorCode) {
                        let errorCode = result.customErrorCode
                        switch (errorCode) {
                            case "Unauthorized":
                            case "401":
                                store.dispatch(logout());
                                window.location.reload();
                                break;

                            case "UnauthorizedAccess":
                            case "800":
                                window.location.href = Project.getPageUrl(AppPages.Home);
                                break;
                            //  case "00010":
                            //        if (!options.skipRefresh) {
                            //            AppManager.refresh(options);
                            //        }
                            //        else {
                            //            AppManager.openLoginWindow(options);
                            //        }
                            //        break;
                            //    case "00011":
                            //        AppManager.openLoginWindow(options);
                            //        break;

                            //    default:
                            //        if (options.showFailure && xhr.statusText != "abort") {
                            //            var message = xhr.getResponseHeader("CustomErrorMessage");
                            //            if (message) {
                            //                Message.error(message, { desc: xhr.getResponseHeader("CustomErrorDescription") }, null, true);
                            //            }
                            //            else if (options.showFailure) {
                            //                Message.failure();
                            //            }
                            //        } break;
                            default:
                                break;
                        }

                        return;
                    }

                    if (options.error)
                        options.error(result);
                    else {

                        message.error(result.message);
                        hideLoader()
                    }
                }
                //else if (result && result.redirectUrl) {
                //    window.location.href = result.redirectUrl;
                //}
                else if (result && result.status === 500) {
                    if (options.error)
                        options.error(result);
                    else
                        message.error(result.title);
                }
                else {
                    if (options.success)
                        options.success(result);
                }
            })
    }
    return controller;
}

export const AjaxPost = function (options) {
    return doProcess(options, "POST");
};
export const AjaxGet = function (options) {
    return doProcess(options, "GET");
};
export const AjaxDownload = function (options) {
    return doProcess({ ...options, download: true }, "POST");
};

export const AjaxUpload = function (options) {
    const formData = new FormData();
    formData.set('file', options.file);

    fetch(options.url, {
        // Your POST endpoint
        //credentials: 'include',
        mode: 'cors',
        method: 'POST',
        headers: {
            // Content-Type may need to be completely **omitted**
            // or you may need something
            //"Content-Type": "multipart/form-data",
            //'USER-TOKEN': token,
            //'CULTURE': store.getState().culture
        },
        body: formData // This is your file object
    }).then(
        response => response.json() // if the response is a JSON object
    ).then(
        request => {
            if (options.success)
                options.success(request);
        }
    ).catch(
        error => {
            console.log(error) // Handle the error response object

            if (options.error)
                options.success(error);
        }
    );


};

export const AjaxUploadXMLHttp = function (options) {
    let formData = new FormData();
    let request = new XMLHttpRequest();

    formData.set('file', options.file);
    request.open("POST", options.url);
    request.send(formData);
    request.onload = function () {
        if (request.readyState === 4) {
            if (request.status === 200) {
                options.success(request);
            } else {
                options.error(request.statusText);
            }
        }
    };
};

export const Ajax = {
    post: (options) => AjaxPost(options),
    get: (options) => AjaxGet(options),
    download: (options) => AjaxDownload(options),
    upload: (options) => AjaxUpload(options),
    uploadXMLHttp: (options) => AjaxUploadXMLHttp(options)
};




